import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Accordion } from 'react-bootstrap';
import SecretariaService from '../../../services/secretaria';
import { Link } from 'react-router-dom';
import Exportar from '../../../components/shared/export'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [nome, setNome] = useState("");
    const [endereco, setEndereco] = useState("");
    const [secretario, setSecretario] = useState("");
    const [palavra, setPalavra] = useState("");

    const busca = async (query) => {
        if (query === "") {
            await props.fetchSecretarias()
            setNome("")
            setEndereco("")
            setSecretario("")
            setPalavra("")
        } else {
            var response = await SecretariaService.buscar(query)
            if (response.data.length >= 1) {
                props.setSecretarias(response.data)
                props.setVazio(false)
                setNome("")
                setEndereco("")
                setSecretario("")
                setPalavra("")
            } else {
                props.setVazio(true)
                setNome("")
                setEndereco("")
                setSecretario("")
                setPalavra("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (nome) prepQuery = prepQuery + `nome=${encodeURI(nome)}`;
        if (endereco) prepQuery = prepQuery + `&endereco=${encodeURI(endereco)}`;
        if (secretario) prepQuery = prepQuery + `&secretario=${encodeURI(secretario)}`;
        if (palavra) prepQuery = prepQuery + `&palavra=${encodeURI(palavra)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={3}>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Secretaria"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Bairro"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="endereco"
                                        value={endereco}
                                        onChange={e => setEndereco(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Secretário(a)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="secretario"
                                        value={secretario}
                                        onChange={e => setSecretario(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Palavra-chave"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="palavra"
                                        value={palavra}
                                        onChange={e => setPalavra(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/orgaos'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                    <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                            <Accordion.Body>
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <Exportar data={props.secretarias} nome={"Secretarias"} />
                                    </Col>
                                </Row>
                                <br />
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#7e569f19-fe9c-4739-8175-afae540064fe" target='_blank'>
                                            <Button>API e sua documentação</Button>
                                        </a>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca